<template>
	<div>
		<div
		 class="expect-job-detail"
		 :class="{'item-error': isError}"
		 @click="showPopup"
		>
			<span
			 class="name-tip"
			 :class="{'title-tip': hasSelected, 'error': isError}"
			>期望职位</span>
			<div class="selected-text">
				<span v-show="hasSelected">{{selectedText}}</span>
			</div>
		</div>
		<checklist
		 v-model="showPop"
		 :data="titleList"
		 :key="checklistKey"
		 :selects="selectedItems"
		 :max="5"
		 title="选择期望职位（可多选）"
		 @on-close="close"
		 @on-confirm="confirm"
		>
		</checklist>
	</div>
</template>
<script>
import { Checklist } from "@58fe/v5";
// import category from "../../../util/category";
import {getConfigJobsData} from "../../../api/configData";
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
	components: {
		Checklist
	},
	data() {
		return {
			// titleList: category,
			titleList:[],
			selectedItems: [], // 选中的职位
			selectedText: "", // 选中职位名字拼接
			selectedIds: "", // 选中职位id拼接
			hasSelected: false,
			showPop: false,
			isError: false,
			checklistKey: 0
		};
	},
	computed: {
		...mapGetters(["sessionCateList", "categoryInitList", "pagetypeLog"])
	},
	watch: {
		selectedItems(val) {
			if (val.length > 0) {
				this.hasSelected = true;
			}
		},
		sessionCateList(val) {
			this.init();
		}
	},
	created() {
		this.getConfigJobsData();
		// 初始化选中项
		this.init();
	},
	methods: {
		init() {
			// 初始化选中项
			let initList = this.categoryInitList;
			if (this.sessionCateList && this.sessionCateList.length > 0) {
				initList = this.sessionCateList;
			}
			if (initList && initList.length > 0) {
				this.selectedItems.push(initList);

				this.confirm(initList);
			}
		},
		showPopup() {
			this.showPop = true;
			window.clickLog &&
				window.clickLog("from=jl_targetcateclick" + this.pagetypeLog);
		},
		close(val) {
			window.clickLog &&
				window.clickLog(
					"from=jl_targetcateclick_close" + this.pagetypeLog
				);

			this.showPop = false;
		},
		confirm(val) {
			let selectState = val.length > 0,
				showIndustry = false; // 是否是二级销售类别

			window.clickLog &&
				window.clickLog(
					"from=jl_targetcateclick_confirm" + this.pagetypeLog
				);

			this.selectedItems = val;
			this.selectedText = "";
			this.selectedIds = "";
			val.forEach((item, i) => {
				if (i > 0) {
					this.selectedText += "/";
					this.selectedIds += ",";
				}
				this.selectedText += item.name;
				this.selectedIds += item.id;

				// 二级类别为销售展示屏蔽行业
				if (item.parentId && item.parentId === 13139) {
					showIndustry = true;
				}
			});

			this.showPop = false;
			this.isError = !selectState;

			// 更改是否展示屏蔽行业状态字段
			this.$store.commit(types.SET_BLOCK_INDUSTRY, showIndustry);

			//  检查是否已填写完整所有必填项
			this.$store.commit(types.CHECK_EXPECTIONINFO, {
				key: "zpcateId",
				value: this.selectedIds,
				state: selectState
			});
		},
		checkNull() {
			this.isError = true;
			window.clickLog &&
				window.clickLog("from=jl_targetcatemiss" + this.pagetypeLog);
		},
			getConfigJobsData(){
				getConfigJobsData().then(data=>{
					let list_0 =[];
					let list_1 =[];
					(data || []).forEach(item => {
								list_0.push({
									id:item.id,
									name:item.name
								});
								if(Array.isArray(item.subList)&&item.subList.length>0){
										let subList = [];
										item.subList.forEach((sub,index)=>{
											subList.push({
												id:sub.DispCategoryID,
												name:sub.CateName
											});
											if(index===item.subList.length-1){
												list_1.push({
													parentId:item.id,
													list:subList
												});
										}
									})
								}
					});
					let list=[list_0,list_1];
					this.titleList = list;
					this.checklistKey = this.checklistKey+1;
				})
		},
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.selected-text {
	height: px2rem(52px);
	overflow: hidden;
	text-overflow: ellipsis;
	span {
		white-space: nowrap;
	}
}
</style>



// WEBPACK FOOTER //
// titleIntention.vue?e7390c28